var map = {
	"./music-instructions.json": 4702,
	"./music-library-intro2024.json": 4703,
	"./music-library-launch2024.json": 4704,
	"./music-progression.json": 4705,
	"./startSourcesAdvanced.json": 4706,
	"./startSourcesSimple.json": 4707,
	"./startSourcesSimple2.json": 4708,
	"./startSourcesTracks.json": 4709
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4471;